import { useState } from 'react';
import { clearSetting, loadFavoriteView, saveSetting, updateFavoriteView } from '@icp/components';
import { useEventCallback } from '@icp/hooks';
import { loadGanttInitState } from './utils';

export default function useGanttSetting({
  defaultGanttState,
  settingKey,
  globalSettingKey,
  settingUrl,
}) {
  const [ganttState, setGanttState] = useState(() =>
    loadGanttInitState(settingKey, globalSettingKey, settingUrl, defaultGanttState),
  );

  const saveGanttState = useEventCallback((newState) => {
    return saveSetting(settingKey, newState);
  });

  const clearGanttState = useEventCallback(() => {
    clearSetting(settingKey);
  });

  const loadFavoriteView1 = useEventCallback(() => {
    return loadFavoriteView(settingKey, globalSettingKey, settingUrl);
  });

  const updateFavoriteView1 = useEventCallback((type, params) => {
    return updateFavoriteView(
      { key: settingKey, globalKey: globalSettingKey, url: settingUrl },
      type,
      params,
    );
  });

  return {
    // current state
    ganttState,
    setGanttState,
    saveGanttState,
    clearGanttState,
    // saved view list
    loadFavoriteView: settingKey && settingUrl ? loadFavoriteView1 : null,
    updateFavoriteView: settingKey && settingUrl ? updateFavoriteView1 : null,
  };
}
